// extracted by mini-css-extract-plugin
module.exports = {"root":"appbar-end_root__hVnLa"};